module.exports = __webpack_public_path__ + "static/media/gr.b32726a7.svg";